<app-header></app-header>
<div class="general-shell content as-body pt-16">
  <router-outlet></router-outlet>
</div>
<app-footer class="mt-auto"></app-footer>